import { Slide, toast, ToastOptions } from 'react-toastify';

const DEFAULT_OPTIONS: ToastOptions = {
  position: "bottom-center",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  theme: "colored",
  transition: Slide,
};


const notify = {
  success: (message) => {
    return toast.success(message, DEFAULT_OPTIONS);
  },
  error: (message) => {
    return toast.error(message, DEFAULT_OPTIONS);
  },
};

export default notify;